var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 23C17.7165 23 18.5 22.2165 18.5 21.25C18.5 20.2835 17.7165 19.5 16.75 19.5C15.7835 19.5 15 20.2835 15 21.25C15 22.2165 15.7835 23 16.75 23Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 23C9.7165 23 10.5 22.2165 10.5 21.25C10.5 20.2835 9.7165 19.5 8.75 19.5C7.7835 19.5 7 20.2835 7 21.25C7 22.2165 7.7835 23 8.75 23Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34 4.44L5.14 6.89C5.1 7.36 5.47 7.75 5.94 7.75H21.25C21.67 7.75 22.02 7.43 22.05 7.01C22.18 5.24 20.83 3.8 19.06 3.8H6.77C6.67 3.36 6.47 2.94 6.16 2.59C5.66 2.06 4.96 1.75 4.24 1.75H2.5C2.09 1.75 1.75 2.09 1.75 2.5C1.75 2.91 2.09 3.25 2.5 3.25H4.24C4.55 3.25 4.84 3.38 5.05 3.6C5.26 3.83 5.36 4.13 5.34 4.44Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0101 9.25H5.67005C5.25005 9.25 4.91005 9.57 4.87005 9.98L4.51005 14.33C4.37005 16.04 5.71005 17.5 7.42005 17.5H18.5401C20.0401 17.5 21.3601 16.27 21.4701 14.77L21.8001 10.1C21.8401 9.64 21.4801 9.25 21.0101 9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingInactive);
export default __webpack_public_path__ + "static/media/shopping-inactive.1723d38c0d6a0b9c7ce084bd531c1d39.svg";
export { ForwardRef as ReactComponent };